import { HttpErrorResponse } from '@angular/common/http';
import { MeasureKind } from '../services/measure-detail.service';
import { ToastService } from '../services/toast.service';
import { measureDeletionKeys } from './measure-deletion-block.util';
import { MEASURE_HAS_CAMPAIGN_VALUES, MEASURE_HAS_AUTOMATIC_VALUES, MEASURE_REFERENCED_BY_ANALYSIS_POST } from './measure-error-codes';

interface ReferencingMeasure {
  id: number;
  name: string;
}

interface MeasureDeletionConflictPayload {
  message?: string;
  code?: string;
  referencing?: readonly ReferencingMeasure[];
}

function extractHttpCause(error: unknown): HttpErrorResponse | undefined {
  if (error instanceof HttpErrorResponse) return error;
  if (error instanceof Error && error.cause instanceof HttpErrorResponse) return error.cause;
  return undefined;
}

function readPayloadCode(payload: MeasureDeletionConflictPayload | undefined): string | undefined {
  if (!payload) return undefined;
  return payload.code ?? payload.message;
}

export function notifyMeasureDeletionError(error: unknown, toastService: ToastService, kind: MeasureKind = 'manual'): void {
  const response = extractHttpCause(error);
  const keys = measureDeletionKeys(kind);

  if (response?.status === 409) {
    const payload = response.error as MeasureDeletionConflictPayload | undefined;
    const code = readPayloadCode(payload);

    if (code === MEASURE_REFERENCED_BY_ANALYSIS_POST && Array.isArray(payload?.referencing) && payload.referencing.length > 0) {
      const names = (payload.referencing as readonly ReferencingMeasure[]).map(r => r.name).join(', ');
      toastService.warning(keys.referenced, undefined, undefined, undefined, { names });
      return;
    }

    if (code === MEASURE_HAS_CAMPAIGN_VALUES || code === MEASURE_HAS_AUTOMATIC_VALUES) {
      toastService.warning(keys.used);
      return;
    }

    toastService.warning(keys.used);
    return;
  }

  const detail = error instanceof Error ? error.message : String(error);
  toastService.error('common.toasts.deleteFailed', undefined, undefined, undefined, { error: detail });
}
